import React, { useContext } from "react";
import { MdClose } from "react-icons/md";
import { BsCartX } from "react-icons/bs";
import { Context } from "../../utils/context";
import CartItem from "./CartItem/CartItem";

import "./Cart.scss";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Cart = () => {
  const { setShowWishlist, cartItems } = useContext(Context);

  const navigate = useNavigate();
  return (
    <div className="cart-panel">
      <div className="opac-layer" onClick={() => setShowWishlist(false)}></div>
      <div className="cart-content">
        <div className="cart-header">
          <span className="heading">Wishlist</span>
          <span className="close-btn" onClick={() => setShowWishlist(false)}>
            <MdClose className="close-btn" />
            <span className="text">close</span>
          </span>
        </div>

        <div className="button absolute bottom-5 text-center w-[80%]  left-[10%] rounded-md  bg-blue-700 text-white py-5 ">
          <button
            onClick={() => {
              navigate("/wishlist");
              setShowWishlist(false);
            }}
            className="checkout-cta"
          >
            View Wishlist
          </button>
        </div>

        {!cartItems?.length && (
          <div className="empty-cart">
            <BsCartX />
            <span>No products in the Wishlist.</span>
            <button className="return-cta" onClick={() => {}}>
              RETURN TO SHOP
            </button>
          </div>
        )}

        {!!cartItems?.length && (
          <>
            <CartItem />
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
